import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { bankFormConfigs, BankFormConfig } from './special-system-model';
import { pago_movil_bank } from './pago-movil-model';
import { bolivia_bank } from './bancos-bolivia-model';

@Component({
    selector: 'app-pago-movil-form',
    templateUrl: './pago-movil-form.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./pago-movil-form.component.scss']
})
export class PagoMovilFormComponent implements OnInit, OnChanges {
    public infoBank: Array<{ codeBank: string; nameBank: string }> = [];
    public accountPagoMovilForm: FormGroup;
    @Input() public systemId: string | undefined;
    @Output() public updatePagoMovilValue: EventEmitter<any> = new EventEmitter();

    public constructor(private formBuilder: FormBuilder) {
        this.accountPagoMovilForm = this.formBuilder.group({
            codeBankPagoMovil: ['', Validators.required],
            phonePagoMovil: ['']
        });
    }

    public ngOnInit(): void {
        this.accountPagoMovilForm.valueChanges.subscribe((value) => {
            let accountPagoMovil: string = value.codeBankPagoMovil + '+' + value.phonePagoMovil;
            this.updatePagoMovilValue.emit(accountPagoMovil);
        });
    }

    public ngOnChanges(): void {
        this.updateBankInfo();
    }

    public getCountryLabel(): string {
        const config: BankFormConfig | undefined = this.getConfig();

        return config ? config.countryLabel : '';
    }

    public getPlaceholder(): string {
        const config: BankFormConfig | undefined = this.getConfig();

        return config && config.placeholder ? config.placeholder : '';
    }

    public getLabel(): string {
        const config: BankFormConfig | undefined = this.getConfig();

        return config ? config.Label : '';
    }

    public getIncorrectSelect(): string {
        const config: BankFormConfig | undefined = this.getConfig();

        return config ? config.incorrectSelect : '';
    }

    public getIncorrectLabel(): string {
        const config: BankFormConfig | undefined = this.getConfig();

        return config ? config.incorrectLabel : '';
    }

    private getConfig(): BankFormConfig | undefined {
        return bankFormConfigs.find((config) => config.id === this.systemId);
    }

    private updateBankInfo(): void {
        let pattern: string = '';
        if (this.systemId === 'pago_movil') {
            pattern = '^(04[0-9]{9})$';
            this.infoBank = pago_movil_bank;
        } else if (this.systemId === 'banco_bol') {
            pattern = '^([0-9]{10,22})$';
            this.infoBank = bolivia_bank;
        }
        this.accountPagoMovilForm.controls.phonePagoMovil.addValidators([Validators.pattern(pattern)]);
        this.accountPagoMovilForm.controls.phonePagoMovil.updateValueAndValidity();
    }
}
